<template>
  <div class="login-container">
    <div class="login-box">

      <div class="avatar-panel">
        <div class="avatar-group" :class="{ 'peeking-mode': isPasswordFocused }">

          <div class="character purple" :style="avatarStyle">
            <div class="body"></div>
            <div class="head">
              <div class="face">
                <div class="eye left"></div>
                <div class="eye right"></div>
                <div class="mouth line"></div>
              </div>
            </div>
          </div>

          <div class="character yellow" :style="avatarStyle">
            <div class="body"></div>
            <div class="head">
              <div class="face">
                <div class="eyebrow left"></div>
                <div class="eyebrow right"></div>
                <div class="eye left"></div>
                <div class="eye right"></div>
                <div class="mouth sad"></div>
              </div>
            </div>
          </div>

          <div class="character black" :style="avatarStyle">
            <div class="body"></div>
            <div class="head">
              <div class="face">
                <div class="eye left-big"></div>
                <div class="eye right-big"></div>
                <div class="mouth smile"></div>
              </div>
            </div>
          </div>

          <div class="character orange" :style="avatarStyle">
            <div class="body"></div>
            <div class="head">
              <div class="face">
                <div class="eye left"></div>
                <div class="eye right"></div>
                <div class="mouth dot"></div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="form-panel">
        <div class="title-container">
          <h2 class="title">欢迎回来</h2>
          <p class="subtitle">请输入您的登录信息</p>
        </div>

        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on">

          <div class="input-group">
            <label class="input-label">用户名</label>
            <el-form-item prop="username">
              <el-input
                  ref="username"
                  v-model="loginForm.username"
                  placeholder="请输入用户名"
                  name="username"
                  type="text"
                  tabindex="1"
              />
            </el-form-item>
          </div>

          <div class="input-group">
            <label class="input-label">密码</label>
            <el-form-item prop="password">
              <el-input
                  ref="password"
                  v-model="loginForm.password"
                  :type="passwordType"
                  placeholder="••••••"
                  name="password"
                  tabindex="2"
                  @focus="passwordFocus"
                  @blur="passwordBlur"
                  @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <i class="el-icon-view" :class="{ 'is-active': passwordType === 'text' }"></i>
              </span>
            </el-form-item>
          </div>

          <el-button :loading="loading" class="btn-login" type="primary" @click.native.prevent="handleLogin">
            登 录
          </el-button>

        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: { username: 'admin', password: '123456' },
      loginRules: {
        username: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
        password: [{ required: true, trigger: 'blur', message: '密码不能少于6位' }]
      },
      passwordType: 'password',
      loading: false,
      mouseX: 0,
      mouseY: 0,
      isPasswordFocused: false
    }
  },
  computed: {
    avatarStyle() {
      const maxMove = 22;
      const x = (this.mouseX / window.innerWidth) * maxMove - (maxMove / 2);
      const y = (this.mouseY / window.innerHeight) * maxMove - (maxMove / 2);
      return {
        '--mx': `${x}px`,
        '--my': `${y}px`
      }
    }
  },
  mounted() { window.addEventListener('mousemove', this.handleMouseMove); },
  beforeDestroy() { window.removeEventListener('mousemove', this.handleMouseMove); },
  methods: {
    handleMouseMove(e) {
      if (this.isPasswordFocused) return;
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
    },
    passwordFocus() { this.isPasswordFocused = true; },
    passwordBlur() { this.isPasswordFocused = false; },
    showPwd() {
      // 切换明文/密文状态
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      // 强制重新聚焦，确保小人保持“非礼勿视”的状态
      this.$nextTick(() => { this.$refs.password.focus() });
    },
    async handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
              .then(() => {
                this.loading = false
                this.$router.push({ path: '/' })
              }).catch(() => { this.loading = false })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh; width: 100%; background-color: #ffffff;
  display: flex; align-items: center; justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.login-box { display: flex; width: 1000px; max-width: 95%; height: 600px; background: #ffffff; }

// ==========================================
// 🎨 纯扁平矢量插画面板
// ==========================================
.avatar-panel {
  flex: 1.1; height: 100%; display: flex; align-items: center; justify-content: center; position: relative;
}
.avatar-group { position: relative; width: 360px; height: 440px; }

.character {
  position: absolute; display: flex; flex-direction: column; align-items: center;

  .head, .body, .face, .eye, .mouth {
    transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .head { position: absolute; z-index: 2; }
  .body { position: absolute; bottom: 0; z-index: 1; }

  .face {
    position: absolute; width: 100%; height: 100%; top: 0; left: 0;
    transform: translate(calc(var(--mx) * 0.4), calc(var(--my) * 0.4));
  }
  .eye {
    position: absolute; background: #0d1117; border-radius: 50%;
    transform: translate(var(--mx), var(--my));
  }
}

/* 1. 紫色高个子 */
.character.purple {
  width: 90px; height: 185px; left: 15px; top: 20px;
  .head { width: 90px; height: 90px; top: 0; background: #7653FC; border-radius: 50%; }
  .body { width: 86px; height: 110px; background: #5D37FA; border-radius: 35px 35px 22px 22px; }
  .eye { width: 7px; height: 7px; top: 46px; &.left { left: 24px; } &.right { right: 24px; } }
  .mouth.line {
    position: absolute; width: 12px; height: 2px; background: #0d1117;
    top: 62px; left: 39px; border-radius: 1px; transform: translate(var(--mx), var(--my));
  }
}

/* 2. 黄色忧郁包 */
.character.yellow {
  width: 90px; height: 155px; right: 15px; top: 110px;
  .head { width: 88px; height: 84px; top: 0; right: 2px; background: #FFD426; border-radius: 50%; transform: rotate(-12deg); }
  .body { width: 74px; height: 85px; right: 0; background: #F2C30F; border-radius: 35px 35px 20px 20px; }
  .eyebrow {
    position: absolute; width: 12px; height: 3.5px; background: #0d1117; top: 25px; border-radius: 2px;
    &.left { left: 18px; transform: translate(var(--mx), var(--my)) rotate(18deg); }
    &.right { right: 18px; transform: translate(var(--mx), var(--my)) rotate(-18deg); }
  }
  .eye { width: 9px; height: 5px; top: 35px; border-radius: 4px; &.left { left: 22px; } &.right { right: 22px; } }
  .mouth.sad {
    position: absolute; width: 12px; height: 6px; border: 2px solid #0d1117; border-bottom: none;
    border-radius: 8px 8px 0 0; top: 54px; left: 36px; transform: translate(var(--mx), var(--my)) rotate(180deg);
  }
}

/* 3. 黑色小方块 —— 💥 修复 3：防止小黑眼睛飞出去 💥 */
.character.black {
  width: 76px; height: 115px; left: 142px; top: 165px;

  .head {
    width: 70px; height: 66px; top: 0; left: -4px;
    background: #1B1A22; border-radius: 20px;
    transform: rotate(-6deg);
    overflow: hidden; /* 这里是限制五官出界的魔法 */
  }

  .body {
    width: 64px; height: 60px; left: 6px;
    background: #121116;
    border-radius: 12px 22px 16px 16px;
  }

  &::before {
    content: ''; position: absolute;
    width: 45px; height: 30px; top: 40px; left: 12px;
    background: #121116; z-index: 1;
    border-radius: 50% 30% 0 0;
    pointer-events: none;
  }

  .face { transform: translate(calc(var(--mx) * 0.3), calc(var(--my) * 0.3)); }

  .eye {
    top: 22px; width: 14px; height: 18px; background: #ffffff; border-radius: 42%;
    transform: translate(var(--mx), var(--my));

    &::after {
      content: ''; position: absolute; width: 6px; height: 6px; background: #000; border-radius: 50%; top: 6px; left: 4px;
      transition: transform 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
    }
    &.left-big { left: 13px; }
    &.right-big { right: 13px; }
  }
  .mouth.smile {
    position: absolute; width: 8px; height: 4px; border: 2px solid #ffffff; border-top: none;
    border-radius: 0 0 6px 6px; top: 46px; left: 29px; transform: translate(var(--mx), var(--my));
  }
}

/* 4. 橙色扁扁怪 */
.character.orange {
  width: 110px; height: 95px; left: 95px; bottom: 30px;
  .head { width: 110px; height: 66px; top: 0; background: #FF6F3C; border-radius: 40px / 30px; }
  .body { width: 104px; height: 45px; background: #E65622; border-radius: 30px 30px 15px 15px; }

  .eye {
    width: 8px; height: 8px; top: 22px;
    &.left { left: 27px; }
    &.right { right: 27px; }
  }

  .mouth.dot {
    position: absolute; width: 6px; height: 6px; background: #0d1117; border-radius: 50%;
    top: 42px; left: 52px; transform: translate(var(--mx), var(--my));
  }
}

// ==========================================
// 🙈 “非礼勿视”避让动效
// ==========================================
.avatar-group.peeking-mode {
  .character {
    .body { transform: skewY(2deg) scaleX(0.95) translateX(-4px); }
    .head { transform: translateX(-6px); }
    &.yellow .head { transform: rotate(-6deg) translateX(-6px); }

    // 小黑配合藏匿的偏移
    &.black .head { transform: translateX(-8px) rotate(-10deg); }

    .face { transform: translate(-12px, 0px) !important; }
    .eye { transform: translate(-6px, 0px) !important; }

    // 限制小黑脸部的极致位移
    &.black .face { transform: translate(-16px, 2px) !important; }

    .mouth.line, .mouth.sad, .mouth.smile, .mouth.dot { transform: translate(-6px, 0px) !important; }

    &.black .eye::after {
      transform: translateX(-4px);
    }
  }
}

// ==========================================
// 右侧：全居中高级 SaaS 表单
// ==========================================
.form-panel {
  flex: 0.9; padding: 40px 60px; display: flex; flex-direction: column; justify-content: center; align-items: center;

  .title-container {
    margin-bottom: 35px; text-align: center;
    .title { font-size: 30px; color: #1a1a1a; font-weight: 700; margin: 0 0 8px 0; letter-spacing: 1px; }
    .subtitle { font-size: 14px; color: #666666; margin: 0; }
  }
  .login-form { width: 100%; max-width: 380px; }
  .input-group { width: 100%; display: flex; flex-direction: column; align-items: center; }
  .input-label { display: block; width: 100%; font-size: 13px; font-weight: 600; color: #2c3e50; margin-bottom: 8px; text-align: left; }

  ::v-deep .el-input { width: 100%; }
  ::v-deep .el-input__inner {
    height: 46px; background: #f7f9fb; border: 1px solid transparent; border-radius: 10px; padding: 0 16px; color: #1a1a1a; font-size: 14px; transition: all 0.2s ease;
    &:focus { background: #ffffff; border-color: #7653FC; box-shadow: 0 0 0 3px rgba(118, 83, 252, 0.12); }
  }
  .el-form-item { width: 100%; margin-bottom: 24px; position: relative; }

  /* 🚀 修改：配合新的图标逻辑，添加了高亮效果 */
  .show-pwd {
    position: absolute; right: 14px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #999; cursor: pointer; z-index: 10; user-select: none; transition: color 0.2s;
    &:hover { color: #666; }
    .is-active { color: #7653FC; } /* 密码可见时，小眼睛变成紫色 */
  }

  .btn-login {
    width: 100%; height: 46px; background: #1A1A24; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; letter-spacing: 2px; color: #ffffff; margin-top: 10px; transition: background 0.2s, transform 0.1s;
    &:hover { background: #2b2b36; } &:active { transform: scale(0.99); }
  }
}

@media (max-width: 850px) {
  .avatar-panel { display: none; }
  .login-box { justify-content: center; }
  .form-panel { flex: 1; padding: 30px 20px; }
}
</style>